/**
 * MoreContent observable.
 */
import contentObservable from './contentObservable';
import slidersObservable from '../sliders/slidersObservable';
import { merge } from 'rxjs';

function moreContentObservable() {
  return merge(slidersObservable('Fun'), contentObservable());
}

export default moreContentObservable;
